import React from 'react';
import BadgeStyled from '../../asset/styled/component/BadgeStyled';

const Badge = ({ children, backgroundColor, color, size }) => {
  return (
    <BadgeStyled backgroundColor={backgroundColor} color={color} size={size}>
      {children}
    </BadgeStyled>
  );
};

export default Badge;
